import script from "./pay.vue?vue&type=script&lang=ts&setup=true"
export * from "./pay.vue?vue&type=script&lang=ts&setup=true"

import "./pay.vue?vue&type=style&index=0&id=40ab2aa6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40ab2aa6"]])

export default __exports__